import type { ProjectDetailedDto } from "@/api/types";

export const getAppBrandName = (appBranding: ProjectDetailedDto["appBranding"]): string => {
  switch (appBranding) {
    case "bpd":
      return "BPD";

    case "areaOfPeople":
    default:
      return "Area of People";
  }
};
